import {gql} from '@apollo/client';
import {getDomainGraphqlError, useMutation$} from 'graphqlsupport';
import {useCallback} from 'react';
import {FullProviderUserInfo, NewProviderUserMutationInput} from '../../../domain/types';
import {showToast} from "common";

export type EditProviderUserMutationInput = {
    oktaId: string;
    payload: Pick<NewProviderUserMutationInput, 'firstName' |
        'lastName' |
        'userManagementAdminAccess' |
        'clientPlacementAccess' |
        'clientReportAccess' |
        'providerMetricsAccess' |
        'rosterAccess' |
        'auditLogAccess' |
        'contactEditAccess' |
        'contactReadAccess' |
        'active'>;
};
type EditProviderUserMutationResult = {
    editProviderUser: FullProviderUserInfo,
};
export const EDIT_PROVIDER_USER_MUTATION = gql`
mutation editProviderUser($oktaId: String!, $payload: EditProviderUserInput) {
  editProviderUser(
    oktaId: $oktaId
    payload: $payload
  ) {
    oktaId
    username
    email
    firstName
    lastName
    providerGuid
    providerName
    status
    clientPlacementAccess
    clientReportAccess
    providerMetricsAccess
    rosterAccess
    auditLogAccess
    contactEditAccess
    contactReadAccess
    userManagementAdminAccess
  }
}
`;
export const useEditProviderUserMutation$ = (onSuccess: (updatedUser: FullProviderUserInfo) => void) => {
    const {execute, isRunning$,} = useMutation$<EditProviderUserMutationInput, EditProviderUserMutationResult>(EDIT_PROVIDER_USER_MUTATION);
    const wrappedExecute = useCallback(async (input: EditProviderUserMutationInput) => {
        try {
            const {data} = await execute({
                variables: input,
            });
            if (data) {
                showToast.success("Permission settings updated successfully.");
                onSuccess(data.editProviderUser);
            }
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to update user. ${errors.message || errors[0].message}`);
            }
        }
    }, [execute, onSuccess]);
    return {
        isRunning$,
        submit: wrappedExecute,
    };
};

